import "./index.scss";
// import { $ } from "@acanto/core-dom";
import { $ } from "@olmokit/dom";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import {
  glide,
  Anchors,
  Breakpoints,
  LazyLoad,
  Swipe,
} from "@olmokit/core/glide";
import "components/Product";

/**
 * Component: ProductSlider
 */
export default function ProductSlider() {
  const $container = $(".ProductSlider:");
  if($container){
    const slider = glide(
      $container,
      {
        loop: false,
        killWhen: { above: 99999 },
        bound: true,
        breakpoints: {
          [99998]: {
            perView: 3,
            gap: 0,
            peek: { before: 0, after: 0 },
          },
          [1200]: {
            perView: 3,
            gap: 0,
            peek: { before: 5, after: 5 },
          },
          [992]: {
            perView: 2.75,
            gap: 0,
            peek: { before: 5, after: 0 },
          },
          [768]: {
            perView: 1.75,
            gap: 0,
            peek: { before: 5, after: 0 },
          },
          576: {
            perView: 1,
            gap: 0,
            peek: { before: 5, after: gridGutter * 2},
          },
        },
      },
      { Swipe, Anchors, Breakpoints, LazyLoad }
    );
    return slider;
  }


}

console.log("ProductSlider mounted.");